export async function startDownload(
	fileUrl: string,
	passedFileName: string,
	blobInput?: string,
	disablePoll?: boolean,
	forceExt?: string,
) {
	try {
		let url = blobInput ? blobInput : fileUrl;
		if (!blobInput && !disablePoll) {
			const response = await fetch(fileUrl);
			const blob = await response.blob();
			url = window.URL.createObjectURL(new Blob([blob]));
		}
		const link = document.createElement("a");
		link.href = url;
		const filenameFromUrl = new URL(fileUrl).pathname.split("/").pop();
		let ext = forceExt ?? filenameFromUrl?.split(".").pop();
		if (fileUrl.startsWith("blob")) {
			ext = ".jpeg";
		}
		const filename = `bria_${passedFileName}.${ext}`;
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		link.parentNode?.removeChild(link);
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export const checkImageHasTransparentPixels = async (imageUrl: string): Promise<boolean> => {
	return new Promise((resolve) => {
		const img = new Image();
		img.crossOrigin = 'anonymous';
		
		img.onload = () => {
			try {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				
				if (!ctx) {
					resolve(false);
					return;
				}
				
				canvas.width = img.width;
				canvas.height = img.height;
				ctx.drawImage(img, 0, 0);
				
				const imageData = ctx.getImageData(0, 0, img.width, img.height);
				const data = imageData.data;
				
				for (let i = 3; i < data.length; i += 4) {
					if (data[i] === 0) {
						resolve(true);
						return;
					}
				}
				
				resolve(false);
			} catch (error) {
				console.error('Error checking image transparency:', error);
				resolve(false);
			}
		};
		
		img.onerror = () => {
			console.error('Error loading image for transparency check');
			resolve(false); 
		};
		
		img.src = imageUrl;
	});
};
